import { AppInitService } from '../services/app-init.service';

/**
 * Factory function to initialize the application
 * This ensures branding and theming information is loaded before the app starts
 */
export function initializeApp(appInitService: AppInitService) {
  return () => appInitService.init();
}
